import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { Filter, FilterTypes } from '@/interfaces/filter'

@Component
export class GetFilterValuesMixin extends Vue {
  get filterValues() {
    let values = _.transform(
      this['filters'] as Filter[],
      (result: Record<string, any>, filter) => {
        result[filter.name] = filter.value
      },
      {}
    )

    values = _.omitBy(values, _.isNil)
    values = _.omitBy(values, v => _.isObject(v) && _.isEmpty(v))
    values = _.omitBy(values, v => v === '')

    return values
  }

  get filterQuery() {
    const values: string[] = []

    this['filters'].forEach((filter: Filter) => {
      let { value } = filter
      if (_.isNil(value) || (_.isObject(value) && _.isEmpty(value)) || value === '') return
      if (Array.isArray(value)) value = value.join()

      if (filter.type === FilterTypes.RANGE_PICKER) {
        Object.keys(filter.value).forEach(condition => {
          values.push(`${filter.name}||${condition}||${value[condition]}`)
        })
      } else {
        values.push(`${filter.name}||${filter.condition || '$eq'}||${value}`)
      }
    })

    return values
  }
}
